import React, { Component } from "react";
import { SketchPicker } from "react-color";
import styled from "styled-components";
import { FormGroup } from "react-bootstrap-3";
import ColorView from "./ColorView";

const Container = styled.div`
  position: relative;
  display: flex;

  .sketch-picker {
    margin-top: 30px;
  }
`;

const Popover = styled.div`
  position: absolute;
  z-index: 302;
`;

const Cover = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

class ColorPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      color: false,
      displayColorPickerInput: false,
    };
  }

  colorpickerInputHandleClick = () => {
    this.setState({
      displayColorPickerInput: !this.state.displayColorPickerInput,
    });
  };

  colorpickerInputHandleClose = () => {
    this.setState({ displayColorPickerInput: false });
  };

  colorpickerHandleChange = color => {
    const { fieldName } = this.props.field;
    this.setState({ color });
    this.props.onChange({ event: undefined, value: color, field: fieldName });
  };

  render() {
    const colorValue = this.state.color || this.props.value;
    const { className, fieldName } = this.props.field;

    return (
      <div className={`ColorPicker ${className}`}>
        <FormGroup>
          <Container>
            <ColorView
              field={{ fieldName }}
              entity={{ [fieldName]: colorValue }}
              onClick={this.colorpickerInputHandleClick}
            />

            <input value={colorValue} onFocus={this.colorpickerInputHandleClick} />

            {this.state.displayColorPickerInput && (
              <Popover>
                <Cover onClick={this.colorpickerInputHandleClose} />
                <SketchPicker
                  color={colorValue}
                  onChange={color => this.colorpickerHandleChange(color.hex)}
                />
              </Popover>
            )}
          </Container>
        </FormGroup>
      </div>
    );
  }
}

export default ColorPicker;
